import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { UrlUtilService } from '../url/url.util.service';
import { catchError, finalize, first, map, Observable } from 'rxjs';
import { SpinnerService } from '../spinner.service';
import { Environment } from 'src/environments/environment.class';
import { ParticulierBancaire } from 'src/app/api/model/particulier-bancaire.model';
import { ReponseCoordonneesBancaire } from 'src/app/api/model/reponse-coordonnees-bancaire.model';

@Injectable({
  providedIn: 'root',
})
export class ChangementCoordonneeBancaireAccesDService {
  private static readonly MSG_ERREUR_GET = 'Erreur lors de la récupération des coordonnées bancaire';
  constructor(
    private readonly httpClient: HttpClient,
    private readonly urlService: UrlUtilService,
    readonly spinnerService: SpinnerService,
    private readonly environment: Environment
  ) {}

  obtenirCoordoonees$(): Observable<ParticulierBancaire> {
    this.spinnerService.afficher();
    return this.httpClient
      .get<ReponseCoordonneesBancaire>(this.urlService.getChangementAdresseAccesDUrl(this.environment.bancaireEndpoint))
      .pipe(
        first(),
        map((data) => this.toCoordonneeMembre(data)),
        catchError((err) => {
          throw err;
        }),
        finalize(() => this.spinnerService.cacher())
      );
  }

  modifierCoordonnees$(payload: Partial<ParticulierBancaire>): Observable<void> {
    this.spinnerService.afficher();
    return this.httpClient
      .patch<void>(this.urlService.getChangementAdresseAccesDUrl(this.environment.bancaireEndpoint), payload)
      .pipe(
        catchError((err) => {
          throw err;
        }),
        finalize(() => this.spinnerService.cacher())
      );
  }

  private toCoordonneeMembre(reponse: ReponseCoordonneesBancaire): ParticulierBancaire {
    if (reponse?.message != null) {
      const err = new Error(ChangementCoordonneeBancaireAccesDService.MSG_ERREUR_GET, { cause: reponse.message });
      throw err;
    }

    if (reponse?.particulierBancaire == null) {
      throw new Error(ChangementCoordonneeBancaireAccesDService.MSG_ERREUR_GET);
    }

    return reponse.particulierBancaire;
  }
}
